import React from 'react';
import PropTypes from 'prop-types';
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
  FormHelperText,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const StyledFormControlLabel = styled(FormControlLabel)({
  marginBottom: '-8px'
});

export default function RadioInput(props) {

  const { errors, label, radios, ref, hideLabel, hideError, squareIcon, ...radioGroupProps } = props;
  const formControlLabels = radios && radios.map((option, key) => {
    return squareIcon ? (<StyledFormControlLabel value={option.value} key={key} label={option.label} control={<Radio icon={<CheckBoxOutlineBlankIcon />} color="primary" checkedIcon={<CheckBoxIcon />} inputRef={ref} />} />) : (<FormControlLabel value={option.value} key={key} label={option.label} control={<Radio color="primary" inputRef={ref} />} />)
  })

  return (
    <div>
      <FormControl component="fieldset" error={!!errors}>

        {(!hideLabel) &&
          <FormLabel component="legend">{label}</FormLabel>
        }

        <RadioGroup {...radioGroupProps} row>
          {formControlLabels}
        </RadioGroup>

        {(!hideError) &&
          <FormHelperText>{errors && errors.message}</FormHelperText>
        }
      </FormControl>
    </div>
  )

}

RadioInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  radios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  ref: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  errors: PropTypes.object,
  hideLabel: PropTypes.bool,
  hideError: PropTypes.bool,
  squareIcon: PropTypes.bool,
}
